import { render, staticRenderFns } from "./eduTrainManage.vue?vue&type=template&id=22e44f2b&scoped=true&"
import script from "./eduTrainManage.vue?vue&type=script&lang=js&"
export * from "./eduTrainManage.vue?vue&type=script&lang=js&"
import style0 from "./eduTrainManage.vue?vue&type=style&index=0&id=22e44f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e44f2b",
  null
  
)

export default component.exports